export default "__VITE_ASSET__DoWRbf7e__"